// extracted by mini-css-extract-plugin
var _1 = "RentalPortalPhotoGalleryTileOverlayFooter-moduleRentalPortalPhotoGalleryTileOverlayFooter__x6P3d";
var _2 = "RentalPortalPhotoGalleryTileOverlayFooter-modulecoverBadge__CXGyU";
var _3 = "RentalPortalPhotoGalleryTileOverlayFooter-moduledragIcon__RV4vy IconNG-moduleiconContainer__SxWZ0";
export { _1 as "RentalPortalPhotoGalleryTileOverlayFooter", _2 as "coverBadge", _3 as "dragIcon" }
